import CountryPageRenderer from '../components/CountryPageRenderer';
import albaniaData from '../data/country-pages/albania';

export default function AlbaniaCountryPage() {
  return <CountryPageRenderer data={albaniaData} />;
}
